import {
  dtoRowToTable, dtoRowToTableWithComplete, tableRowToDto, dtoYearValuesToTable,
} from '../dto/facts';
import api from '../api';
import { BaseRequests } from '../requests/BaseRequests';

const factKpisType = 'Данные для расчета фактических значений по показателям';

export const getAllFacts = async () => {
  const result = await api.get(`/kpis/0/vals?type=${factKpisType}`);
  return result.map(dtoRowToTable);
};

export const getAllUnified = async (params) => {
  const url = BaseRequests.getUrlSearch('/reports/fixedPcs', params)
  const result = await api.get(url);
  if (result.error){
    throw new Error(result.error.message)
  }
  return result.map(dtoRowToTable);
};

export const getUnifiedByEntityId = async (entityId, params) => {
  const url = BaseRequests.getUrlSearch(`/reports/fixedPcs/${entityId}`, params)
  const result = await api.get(url);
  if (result.error){
    throw new Error(result.error.message)
  }
  return result.map(dtoRowToTable);
};

export const updateFactsRow = async (tableRow, years, strategyId) => {
  const postData = tableRowToDto(tableRow, years);

  if (strategyId) { postData.strategyId = strategyId; }
  if (tableRow.stratKpiRole !== undefined) { postData.stratKpiRole = tableRow.stratKpiRole; }

  const response = await api.post(`/kpis/${tableRow.id}/vals`, postData);
  return response.reduce((acc, v) => ({ ...acc, ...dtoYearValuesToTable(v) }), {});
};

export const getAllResults = async () => {
  const result = await api.get('/kpis/0/results');
  return result.map(dtoRowToTableWithComplete);
};
